<div class="ui-error position-relative text-center">
  @if (!errorRequests().hideErrorIcon) {
    <i class="pi pi-exclamation-triangle mb-4"></i>
  }
  <p [ngClass]="{ h5: !errorRequests().hideMainAction }">
    <span class="rr-text-danger">Ooops!</span>
    <span class="ms-2 error-description">{{ errorRequests().errorDescription ?? "An error occurred." }}</span>
    @if (errorRequests().showSubMessage) {
      <span class="mt-2 d-block error-sub-description">Please refresh the page or try again later.</span>
    }
  </p>
  <div class="d-flex gap-2 justify-content-center">
    @if (!errorRequests().hideMainAction) {
      <p-button
        styleClass="mt-1 border-0 main-action-btn {{ !errorRequests().hasTheme ? 'ag-bg-blue' : '' }}"
        [label]="errorRequests().mainActionlabel ?? 'Go back to Home'"
        [outlined]="false"
        (onClick)="errorEvent.emit()"
      ></p-button>
    }
    @if (errorRequests().showLogout) {
      <p-button
        styleClass="mt-1 border-0 logout-btn {{ !errorRequests().hasTheme ? 'ag-bg-blue' : '' }}"
        [label]="'Log out'"
        [outlined]="false"
        (onClick)="logout.emit()"
      ></p-button>
    }
  </div>
</div>
